import PropTypes from 'prop-types';
import { FormattedMessage } from 'dibs-react-intl';

const labels = {
    furniture: <FormattedMessage id="CreatorsVerticalName.furniture" defaultMessage="Furniture" />,
    art: <FormattedMessage id="CreatorsVerticalName.art" defaultMessage="Fine Art" />,
    jewelry: (
        <FormattedMessage id="CreatorsVerticalName.jewelry" defaultMessage="Jewelry & Watches" />
    ),
    fashion: <FormattedMessage id="CreatorsVerticalName.fashion" defaultMessage="Fashion" />,
};

export function CreatorsVerticalName({ vertical }) {
    return labels[vertical];
}

CreatorsVerticalName.propTypes = {
    vertical: PropTypes.string.isRequired,
};
